import axios from 'axios';
import { getIdToken } from '../utils/auth';

const API_ENDPOINT_BASE_URL = process.env.NODE_ENV == 'production' ? 'https://z23vm3xw0k.execute-api.us-east-1.amazonaws.com/production' : 'https://waoxjng7n9.execute-api.us-east-1.amazonaws.com/dev';

export { getReports, archiveReport, renewReport };

function getReports(sinceDate, status, exclusiveStartReport) {
  const url = `${API_ENDPOINT_BASE_URL}/reports`;
  const _sinceDate = sinceDate || null;
  var _status = status.toLowerCase();
  if (!['new', 'archived'].includes(_status)) { _status = null; }
  const _exclusiveStartReport = exclusiveStartReport || null;
  var params = {};
  if (_sinceDate) { params['sinceDate'] = _sinceDate.valueOf(); }
  if (_status) { params['status'] = _status; }
  if (_exclusiveStartReport) { params['exclusiveStartId'] = _exclusiveStartReport.id; params['exclusiveStartStatus'] = _exclusiveStartReport.status; params['exclusiveStartCreatedAt'] = _exclusiveStartReport.createdAt; }
  return axios.get(url, {
    headers: { Authorization: `${getIdToken()}` },
    params: params,
  }).then(response => response.data);
}

function archiveReport(report) {
  const url = `${API_ENDPOINT_BASE_URL}/reports/${report.id}_${report.createdAt}`;
  return axios.patch(url, { 'status': 'archived' }, {
    headers: { Authorization: `${getIdToken()}` },
  }).then(response => response.data);
}

function renewReport(report) {
  const url = `${API_ENDPOINT_BASE_URL}/reports/${report.id}_${report.createdAt}`;
  return axios.patch(url, { 'status': 'new' }, {
    headers: { Authorization: `${getIdToken()}` },
  }).then(response => response.data);
}
